/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { cityIOSettings } from "../../settings/settings";
import {
  updateLayers,
  toggleLayersIsDone,
} from "../../redux/reducers/dataSlice";
import { useSelector, useDispatch } from "react-redux";
import LoadingProgressBar from "../LoadingProgressBar";
import NextUpdateTimer from "../NextUpdateTimer";
import "./style.css";

const CityIO = () => {
  const dispatch = useDispatch();
  const [arrLoading, setArrLoading] = useState([]);
  const [cityIOisDone, setCityIOisDone] = useState(false);
  const [nextUpdate, setNextUpdate] = useState(600); // Segundos hasta próxima actualización

  const layers = useSelector((state) => state.dataState.layers);
  const layersRef = useRef(layers);
  
  // Actualizar la referencia cada vez que cambian los layers
  useEffect(() => {
    layersRef.current = layers;
  }, [layers]);

  useEffect(() => {
    const downloadLayerData = async () => {
      console.log("Downloading layers data");
      setArrLoading(['Descargando capas y datos satelitales...']);

      // Cargar todos los layers en paralelo
      const updatedLayers = await Promise.all(
        layers.map(async (layer) => {
          if (!layer.url) {
            return { ...layer };
          }

          try {
            const res = await fetch(layer.url);
            const data = await res.json();
            return { ...layer, geojson: data, data: data };
          } catch (error) {
            console.error(`Error loading ${layer.id}:`, error);
            return { ...layer };
          }
        })
      );

      // focos, area_focos y jams ya vienen cada uno de su propio archivo en
      // dynamic/ — no hay que derivar coverage de focos.
      dispatch(updateLayers(updatedLayers));
      dispatch(toggleLayersIsDone(true));
      setCityIOisDone(true);
      setArrLoading([]);
    }

    // Cargar datos inmediatamente
    downloadLayerData();

    // Actualizar wildfires cada 10 minutos (600000 ms)
    const updateWildfires = async () => {
      console.log("Updating wildfires and traffic data...");
      
      // Obtener el estado actual de layers desde la referencia
      const currentLayers = layersRef.current;
      const focosLayer = currentLayers.find(l => l.id === 'focos');
      const areaFocosLayer = currentLayers.find(l => l.id === 'area_focos');
      const jamsLayer = currentLayers.find(l => l.id === 'jams');

      // Refrescar las 3 capas dinámicas desde el CDN en paralelo.
      const updates = await Promise.all([
        focosLayer?.url ? fetch(focosLayer.url).then(r => r.json()).catch(e => null) : null,
        areaFocosLayer?.url ? fetch(areaFocosLayer.url).then(r => r.json()).catch(e => null) : null,
        jamsLayer?.url ? fetch(jamsLayer.url).then(r => r.json()).catch(e => null) : null
      ]);

      const [focosData, areaFocosData, jamsData] = updates;

      // Actualizar focos, area_focos y jams, preservando el resto
      const updatedLayers = currentLayers.map(layer => {
        if (layer.id === 'focos' && focosData) {
          return {
            ...layer,
            geojson: focosData,
            data: focosData
          };
        }
        if (layer.id === 'area_focos' && areaFocosData) {
          return {
            ...layer,
            geojson: areaFocosData,
            data: areaFocosData
          };
        }
        if (layer.id === 'jams' && jamsData) {
          return {
            ...layer,
            geojson: jamsData,
            data: jamsData
          };
        }
        // Preservar el layer con todos sus datos existentes
        return { ...layer };
      });
      
      dispatch(updateLayers(updatedLayers));
      console.log("Wildfires and traffic data updated successfully");
      setNextUpdate(600); // Reiniciar contador a 10 minutos
    };

    const intervalId = setInterval(updateWildfires, 10 * 60 * 1000); // 10 minutos

    // Countdown timer que se actualiza cada segundo
    const countdownId = setInterval(() => {
      setNextUpdate(prev => Math.max(0, prev - 1));
    }, 1000);

    // Limpiar intervalos al desmontar
    return () => {
      clearInterval(intervalId);
      clearInterval(countdownId);
    };
  }, [])

  return !cityIOisDone ? (
    <LoadingProgressBar arr={arrLoading} />
  ) : (
    <NextUpdateTimer nextUpdate={nextUpdate} />
  );
};

export default CityIO;
